type SaveBlob = (blob: Blob, defaultName?: string) => boolean

type DownloadNavigator = Navigator &
    ({ msSaveOrOpenBlob: SaveBlob; msSaveBlob: SaveBlob } | { msSaveOrOpenBlob?: undefined; msSaveBlob?: undefined })

export const downloadBlob = (blobData: BlobPart, name: string = 'data') => {
    const blob = new Blob([blobData], { type: 'text/csv' })
    const browserNavigator = window.navigator as DownloadNavigator

    if (browserNavigator && browserNavigator.msSaveOrOpenBlob) {
        browserNavigator.msSaveBlob(blob, `${name}.csv`)
    } else {
        const elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = `${name}.csv`
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
    }
}
